import templateUrl from './admin-user-add-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onUserChanged: '&'
  },
  controller: class AdminUserAddFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.user = this.user || {};
      this.user.UserTypeId = 4;
      this.user.TypeReferenceId = -1;
      this.user.LevelOfAccess = 4;
    }

    onSubmit() {
      this.onUserChanged(
        this.EventEmitter({
          user: this.user
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-add-form/admin-user-add-form.component.js